import React, { useRef } from "react";
import { Controller } from "react-hook-form";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useSelector } from "react-redux";

const CommonPhoneInput = ({ control, name = "mobileNo", setValue, ...props }) => {
    const phoneInputRef = useRef(null);
    const authState = useSelector((state) => state.auth);
    const country = authState?.isoCode;


    if (!control) {
        return (
            <PhoneInput
                ref={phoneInputRef}
                country={country?.toLowerCase() || "in"}
                onlyCountries={country ? [country.toLowerCase()] : []}
                enableSearch={!country}
                disableDropdown={!!country}
                countryCodeEditable={!country}
                inputStyle={{
                    width: "100%",
                    height: "46px",
                    padding: "10px",
                    paddingLeft: "50px",
                    fontSize: "16px",
                    borderRadius: "8px",
                    borderColor: "rgba(83, 70, 134, 0.1019607843)",
                }}
                searchClass="none"
                {...props}
            />
        );
    }

    return (
        <Controller
            name={name}
            control={control}
            render={({ field }) => (
                <PhoneInput
                    {...field}
                    ref={(ref) => {
                        phoneInputRef.current = ref;
                        if (ref) {
                            try {
                                field.ref({
                                    focus: () => {
                                        phoneInputRef.current?.numberInputRef?.focus();
                                    },
                                });
                            } catch (e) { }
                        }
                    }}
                    value={field.value}
                    country={country?.toLowerCase() || "in"}
                    // onlyCountries={country ? [country.toLowerCase()] : []}

                    onChange={(value, countryData) => {
                        setValue("countryCode", countryData.dialCode);
                        field.onChange(value);
                    }}
                    inputStyle={{
                        width: "100%",
                        height: "46px",
                        padding: "10px",
                        paddingLeft: "50px",
                        fontSize: "16px",
                        borderRadius: "8px",
                        borderColor: "rgba(83, 70, 134, 0.1019607843)",
                    }}
                    searchClass="none"
                    {...props}
                />
            )}
        />
    );
};

export default CommonPhoneInput;